import React, {forwardRef, Fragment, useState} from 'react'
import menu from '../../Main/menu'
import {AppBar, Button, Container, makeStyles, Toolbar, Typography, InputBase, alpha, IconButton, Menu, Hidden, MenuItem} from '@material-ui/core'
import {Search as SearchIcon, Menu as MenuIcon} from '@material-ui/icons'
import { Link, NavLink } from 'react-router-dom'
import {RiLogoutCircleRLine} from 'react-icons/ri'
import {FaShoppingBasket, FaUserCircle} from 'react-icons/fa'
import SlideToggle from "react-slide-toggle";

const useStyles = makeStyles(theme => ({
    header: {
        width: '100%',
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none'
    },
    topbarWrapper:{
        background: `linear-gradient(180deg, ${theme.palette.secondary.light}, rgba(0,0,0,0))`,
        padding: '20px 0',
    },
    headerContainer:{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        // backgroundColor: 'yellow',
        padding: '0'
    },
    navbar:{
        display: 'flex'
    },
    navItem:{
        margin: '0 10px',
        color: 'white',
        textTransform: 'capitalize',
        fontSize: '15px',
        fontWeight: '200',
        letterSpacing: '1',
        textDecoration: 'none'
    },
    activeNav:{
        color: theme.palette.primary.main,
        fontWeight:600
    },
    menuBtn:{
        color: 'white'
    },
    iconBtn:{
        color: 'white',
        '&:hover':{
            color: theme.palette.primary.main
        }
    },
    mobileNav:{
        width: '100%',
        padding: '10x 0',
        backgroundColor: 'black',
        borderTop: '1px solid white',
        borderBottom: '1px solid white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    mobileNavItem: {
        width: '100%',
        // backgroundColor: 'red',
        textAlign: 'center',
        textDecoration: 'none',
        color: 'white',
        fontWeight: '200',
        margin: '10px 0'
    },
    activeMobileNav: {
        color: theme.palette.primary.main,
        fontWeight:600
    }
}))

const customRouterLink = forwardRef((props, ref) => (
    <div ref={ref}>
        <NavLink {...props} />
    </div>
))

function Topbar(props) {
    const classes = useStyles()
    const {openSidebar} = props
    const [anchorProfileMenu, setAnchorProfileMenu] = useState(null)
    const toggleMobileNav = () => {
        setMblNavTgl(Date.now())
    }
    const handleProfileMenuOpen = (e) => {
        setAnchorProfileMenu(e.currentTarget)
    }
    const handleProfileMenuClose = (e) => {
        setAnchorProfileMenu(null)
    }
    const [mblNavTgl, setMblNavTgl] = useState(0)
    return (
        <Fragment>
            <AppBar className={classes.header}>
                <div className={classes.topbarWrapper}>
                    <Container>
                        <Toolbar className={classes.headerContainer}>
                            {/* <Hidden only={['lg','xl']}>
                                <IconButton className={classes.menuBtn} onClick={toggleMobileNav}><MenuIcon /></IconButton>
                            </Hidden> */}
                            <Link to="/"><img src="/assets/images/logo.png" /></Link>
                            {/* <Hidden only={['xs','sm','md']} >
                                <div className={classes.navbar}>
                                    {menu.map((item) => (
                                        <NavLink className={classes.navItem} to={item.path}  activeClassName={classes.activeNav}>
                                            {item.title}
                                        </NavLink>
                                    ))}
                                </div>
                            </Hidden> */}
                            {/* <IconButton className={classes.iconBtn} onClick={handleProfileMenuOpen}>
                                <FaUserCircle />
                            </IconButton>
                            <Menu
                                anchorEl={anchorProfileMenu}
                                keepMounted
                                open={Boolean(anchorProfileMenu)}
                                onClose={handleProfileMenuClose}
                            >
                                <MenuItem onClick={handleProfileMenuClose}>Profile</MenuItem>
                                <MenuItem onClick={handleProfileMenuClose}>Log Outt</MenuItem>
                            </Menu> */}
                           
                        </Toolbar>

                    </Container>
                </div>
                {/* <Hidden only={['lg','xl']}>
                    <SlideToggle
                        duration={400}
                        toggleEvent={mblNavTgl}
                        render={({  setCollapsibleElement }) => (
                            <div className={classes.mobileNav}  ref={setCollapsibleElement}>
                                {menu.map((item) => (
                                    <NavLink className={classes.mobileNavItem} to={item.path} onClick={toggleMobileNav}  activeClassName={classes.activeMobileNav}>
                                        {item.title}
                                    </NavLink>
                                ))}
                            </div>
                        )}
                    >
                    
                    </SlideToggle>
                </Hidden> */}
                
            </AppBar>
            
        </Fragment>
    )
}

export default Topbar
